// ** Logo
import logo from "@src/assets/images/logo/logo.svg";
import logoEn from "@src/assets/images/logo/en/logo-concept.png";
import { useRTL } from '@hooks/useRTL';

const SpinnerComponent = () => {
  const [isRtl, setIsRtl] = useRTL()

  return (
    <div className="fallback-spinner vh-100 d-flex align-items-center justify-content-center">
      <div
        className="animate__animated animate__tada"
        style={{
          width: "350px",
          height: "200px",
        }}
      >
        <img
          className="fallback-logo"
          src={isRtl ? logo : logoEn}
          alt="logo"
          style={{
            width: "450px",
            height: "250px",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>
    </div>
  );
};

export default SpinnerComponent;
